import React, { forwardRef } from 'react';
import { Alert, AlertTitle } from '@mui/material';
import { TranslatedText } from '@ianesthesie-kit/core';

export type AsaSnackProps = {
  asa: string | undefined;
};
export const AsaSnack = forwardRef<
  HTMLDivElement,
  AsaSnackProps & { style: any }
>(({ asa, style }, ref) => {
  const isUnknown = !asa;
  return (
    <Alert
      ref={ref}
      style={style}
      variant="filled"
      severity={isUnknown ? 'warning' : 'info'}
    >
      {isUnknown && (
        <>
          <AlertTitle>
            <TranslatedText id="doctor-dashboard.asa.updateSnackbar.unknown.title" />
          </AlertTitle>
          <TranslatedText id="doctor-dashboard.asa.updateSnackbar.unknown.message" />
        </>
      )}

      {!isUnknown && (
        <TranslatedText
          id="doctor-dashboard.asa.updateSnackbar"
          values={{
            asa
          }}
        />
      )}
    </Alert>
  );
});

AsaSnack.displayName = 'AsaSnack';
